import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router";
import { Breadcrumbs as BreadcrumbsMUI, Link, useMediaQuery } from "@mui/material";
import NavBarPortal from "../Layout/NavBar/NavBarPortal";
import "./BreadCrumbs.scss";

const Breadcrumbs = ({ list, className, BreadCrumbHasBackIcon }) => {
  const history = useHistory();
  const isMobile = useMediaQuery("(max-width:768px)");
  const navBarClassName = className
    ?.split(" ")
    .filter((name) => !/^m[btxyse]?-\d+$/.test(name))
    .join(" ");

  const clickHandler = (element) => {
    if (element.isClicked && typeof element.onclick === "function") {
      element.onclick();
      return;
    }
    if (element.path) {
      const [pathname, query = ""] = element.path.split("?");
      history.push({
        pathname,
        search: query ? `?${query}` : "",
        ...(element.state ? { state: element.state } : {}),
      });
    }
  };

  const content = (
    <div className="bread-crumbs">
      <BreadcrumbsMUI
        className={navBarClassName}
        maxItems={isMobile ? 3 : 8}
        itemsBeforeCollapse={1}
        itemsAfterCollapse={1}
      >
        {list?.length > 0 ? (
          list?.map((element, i) => {
            return (
              <Link
                key={element.label}
                underline="none"
                onClick={() => clickHandler(element)}
                className={`${list.length > 1 ? "pointer" : ""} ${
                  i === list?.length - 1
                    ? "active-bread-crumb-link"
                    : "bread-crumb-link"
                }`}
              >
                <span
                  className={`bread-crumb-label${
                    BreadCrumbHasBackIcon
                      ? " d-flex justify-content-center align-items-center"
                      : ""
                  }`}
                >
                  {element.label}
                </span>
              </Link>
            );
          })
        ) : (
          <></>
        )}
      </BreadcrumbsMUI>
    </div>
  );

  return <NavBarPortal fallbackToInline>{content}</NavBarPortal>;
};
export default Breadcrumbs;
Breadcrumbs.propTypes = {
  list: PropTypes.array.isRequired,
  className: PropTypes.string,
  BreadCrumbHasBackIcon: PropTypes.bool,
};
